export default __webpack_public_path__ + "static/media/p2p.13232538.webp";